const DeliveryType = require('../enums/delivery-type');

class DeliveryManager {

    constructor() { }

    getTitle(delivery) {
        const deliveryType = delivery.type
        const deliverySurface = delivery.surface.toString()
        switch (deliveryType) {
            case DeliveryType.CUSTOM:
                return delivery.title
            case DeliveryType.APARTMENT:
                return 'Appartement : Check pré-achat'
            case DeliveryType.HOME:
                return 'Maison & Villa'
            case DeliveryType.HOME_WITH_ROOFTOP:
                return 'Maison & Villa - forfait avec toiture'
            case DeliveryType.COUNTERVISIT:
                return 'Contre visite'
            case DeliveryType.SWIMMING_POOL:
                return 'Piscine'
            case DeliveryType.ROOFING:
                return 'Toiture & Combles'
            case DeliveryType.GARDEN:
                return 'Jardin'
            case DeliveryType.WATERING:
                return 'Arrosage'
            case DeliveryType.CRAWLSPACE:
                return 'Vide-sanitaire'
            case DeliveryType.GARDEN_WATERING:
                return 'Jardin & Arrosage'
            case DeliveryType.VEFA_HOME_BULKHEAD:
                return 'VEFA - Maison - Visite cloisons'
            case DeliveryType.VEFA_HOME_PRE_DELIVERY:
                return 'VEFA - Maison - Pré-livraison / Réserves'
            case DeliveryType.VEFA_HOME_RECEPTION_DELIVERY:
                return 'VEFA - Maison - Réception / Livraison'
            case DeliveryType.VEFA_APARTMENT_BULKHEAD:
                return 'VEFA - Appartement - Visite cloisons'
            case DeliveryType.VEFA_APARTMENT_PRE_DELIVERY:
                return 'VEFA - Appartement - Pré-livraison / Réserves'
            case DeliveryType.VEFA_APARTMENT_RECEPTION_DELIVERY:
                return 'VEFA - Appartement - Réception / Livraison'
            case DeliveryType.MOISTURE_CHECK:
                return 'Check humidité'
            case DeliveryType.DELIVERY_ASSISTANCE_COMMON_PART:
                return 'Assistance à livraison des parties communes'
            case DeliveryType.CCMI_FOUNDATION:
                return 'Visite fondation CCMI'
            case DeliveryType.CCMI_BIG_WORK:
                return 'Visite Gros Oeuvre CCMI'
            case DeliveryType.CCMI_BULKHEAD:
                return 'Visite cloisons CCMI'
            case DeliveryType.CCMI_COPE:
                return 'Visite Chape CCMI'
            case DeliveryType.CCMI_RECEPTION_DELIVERY:
                return 'Réception & Livraison CCMI'
            case DeliveryType.CCMI_SERENITY_PACK:
                return 'Pack Sérénité CCMI - 5 Visites'
            case DeliveryType.CRACKS_CHECK:
                return 'Check fissures'
            case DeliveryType.FOLLOW_UP_CONSTRUCTION_SITE_ONE_MONTH:
                return 'Suivi de chantier hors VEFA CCMI - Pack 1 mois (tarif mensuel)'
            case DeliveryType.FOLLOW_UP_CONSTRUCTION_SITE_THREE_MONTHS:
                return 'Suivi de chantier hors VEFA CCMI - Pack 3 mois (tarif mensuel)'
            case DeliveryType.FOLLOW_UP_CONSTRUCTION_SITE_SIX_MONTHS:
                return 'Suivi de chantier hors VEFA CCMI - Pack 6 mois (tarif mensuel)'
            case DeliveryType.FOLLOW_UP_CONSTRUCTION_SITE_ALL_INCLUDED:
                return 'Suivi de chantier hors VEFA CCMI - Jusqu\'à remise des clés (tarif mensuel)'
            case DeliveryType.RECEPTION_CONSTRUCTION_SITE:
                return 'Réception de chantier hors VEFA CCMI'
            case DeliveryType.APARTMENT_INVENTORY_FURNISHED:
                return 'État des lieux - Appartement meublé T' + deliverySurface
            case DeliveryType.APARTMENT_INVENTORY_NOT_FURNISHED:
                return 'État des lieux - Appartement non meublé T' + deliverySurface
            case DeliveryType.HOME_INVENTORY_FURNISHED:
                return 'État des lieux - Maison meublé T' + deliverySurface
            case DeliveryType.HOME_INVENTORY_NOT_FURNISHED:
                return 'État des lieux - Maison non meublé T' + deliverySurface
            case DeliveryType.GO_NO_GO_APARTMENT:
                return '"Go/No Go - Appartement"' + deliverySurface
            case DeliveryType.GO_NO_GO_HOME:
                return '"Go/No Go - Maison"' + deliverySurface
            default:
                console.log('Sorry, we are out of ' + deliveryType + '.');
                return 'Erreur 17'
        }
    }

    getQuantity(deliveryType, surface) {
        switch (deliveryType) {
            case DeliveryType.CUSTOM:
                return 1
            case DeliveryType.HOME:
                return 1
            case DeliveryType.HOME_WITH_ROOFTOP:
                return 1
            case DeliveryType.APARTMENT:
                return 1
            case DeliveryType.CRAWLSPACE:
                return surface
            case DeliveryType.VEFA_LIFTING_RESERVATION:
                return surface
            case DeliveryType.VEFA_HOME_BULKHEAD:
                return 1
            case DeliveryType.VEFA_HOME_PRE_DELIVERY:
                return 1
            case DeliveryType.VEFA_HOME_RECEPTION_DELIVERY:
                return 1
            case DeliveryType.VEFA_APARTMENT_BULKHEAD:
                return 1
            case DeliveryType.VEFA_APARTMENT_PRE_DELIVERY:
                return 1
            case DeliveryType.VEFA_APARTMENT_RECEPTION_DELIVERY:
                return 1
            case DeliveryType.SWIMMING_POOL:
                return surface
            case DeliveryType.COUNTERVISIT:
                return 1
            case DeliveryType.GARDEN:
                return surface
            case DeliveryType.WATERING:
                return surface
            case DeliveryType.GARDEN_WATERING:
                return surface
            case DeliveryType.MOISTURE_CHECK:
                return 1
            case DeliveryType.DELIVERY_ASSISTANCE_COMMON_PART:
                return surface
            case DeliveryType.CCMI_FOUNDATION:
                return 1
            case DeliveryType.CCMI_BIG_WORK:
                return 1
            case DeliveryType.CCMI_BULKHEAD:
                return 1
            case DeliveryType.CCMI_COPE:
                return 1
            case DeliveryType.CCMI_RECEPTION_DELIVERY:
                return 1
            case DeliveryType.CCMI_SERENITY_PACK:
                return 1
            case DeliveryType.CRACKS_CHECK:
                return 1
            case DeliveryType.FOLLOW_UP_CONSTRUCTION:
                return 1
            case DeliveryType.RECEPTION_CONSTRUCTION_SITE:
                return 1
            case DeliveryType.APARTMENT_INVENTORY_FURNISHED:
                return 1
            case DeliveryType.APARTMENT_INVENTORY_NOT_FURNISHED:
                return 1
            case DeliveryType.HOME_INVENTORY_FURNISHED:
                return 1
            case DeliveryType.HOME_INVENTORY_NOT_FURNISHED:
                return 1
            case DeliveryType.GO_NO_GO_APARTMENT:
                return 1
            case DeliveryType.GO_NO_GO_HOME:
                return 1
            default:
                console.log('Sorry, we are out of ' + deliveryType + '.');
                return 0
        }
    }

    getUnitPricing(deliveryType, surface) {
        switch (deliveryType) {
            case DeliveryType.CUSTOM:
                return parseFloat(surface)
            case DeliveryType.VEFA_LIFTING_RESERVATION:
                return 8
            case DeliveryType.VEFA_HOME_BULKHEAD:
                if (surface <= 50)
                    return 550 // forfait
                return 550 + (surface - 50) * 3
            case DeliveryType.VEFA_HOME_PRE_DELIVERY:
                if (surface <= 50)
                    return 580 // forfait
                return 580 + (surface - 50) * 3
            case DeliveryType.VEFA_HOME_RECEPTION_DELIVERY:
                if (surface <= 50)
                    return 610 // forfait
                return 610 + (surface - 50) * 3
            case DeliveryType.VEFA_APARTMENT_BULKHEAD:
                if (surface <= 50)
                    return 480 // forfait
                return 480 + (surface - 50) * 3
            case DeliveryType.VEFA_APARTMENT_PRE_DELIVERY:
                if (surface <= 50)
                    return 510 // forfait
                return 510 + (surface - 50) * 3
            case DeliveryType.VEFA_APARTMENT_RECEPTION_DELIVERY:
                if (surface <= 50)
                    return 530 // forfait
                return 530 + (surface - 50) * 3
            case DeliveryType.APARTMENT:
                if (surface <= 50)
                    return 510 // forfait
                return 510 + (surface - 50) * 3
            case DeliveryType.HOME:
                if (surface <= 50)
                    return 650 // forfait
                return 650 + (surface - 50) * 3
            case DeliveryType.COUNTERVISIT:
                return 150
            case DeliveryType.SWIMMING_POOL:
                return 480
            case DeliveryType.GARDEN:
                if (surface <= 500)
                    return 0.55
                else if (surface <= 1000)
                    return 0.50
                return 0.45
            case DeliveryType.WATERING:
                if (surface <= 500)
                    return 0.55
                else if (surface <= 1000)
                    return 0.50
                return 0.45
            case DeliveryType.GARDEN_WATERING:
                if (surface <= 500)
                    return 0.70
                else if (surface <= 1000)
                    return 0.65
                return 0.60
            case DeliveryType.CRAWLSPACE:
                return 4.1
            case DeliveryType.MOISTURE_CHECK:
                if (surface <= 100)
                    return 510 // forfait
                return 510 + (surface - 100) * 3
            case DeliveryType.DELIVERY_ASSISTANCE_COMMON_PART:
                return 45
            case DeliveryType.CCMI_FOUNDATION:
                if (surface <= 75)
                    return 510 // forfait
                return 510 + (surface - 75) * 3
            case DeliveryType.CCMI_BIG_WORK:
                if (surface <= 75)
                    return 590 // forfait
                return 590 + (surface - 75) * 3
            case DeliveryType.CCMI_BULKHEAD:
                if (surface <= 75)
                    return 550 // forfait
                return 550 + (surface - 75) * 3
            case DeliveryType.CCMI_COPE:
                if (surface <= 75)
                    return 510 // forfait
                return 510 + (surface - 75) * 3
            case DeliveryType.CCMI_RECEPTION_DELIVERY:
                if (surface <= 75)
                    return 720 // forfait
                return 720 + (surface - 75) * 3
            case DeliveryType.CCMI_SERENITY_PACK:
                if (surface <= 75)
                    return 390 * 5 // forfait
                return (390 + (surface - 75) * 3) * 5
            case DeliveryType.CRACKS_CHECK:
                if (surface <= 100)
                    return 510 // forfait
                return 510 + (surface - 100) * 3
            case DeliveryType.FOLLOW_UP_CONSTRUCTION:
                if (surface <= 100)
                    return 450 // forfait
                return 450 + (surface - 100) * 3
            case DeliveryType.RECEPTION_CONSTRUCTION_SITE:
                if (surface <= 100)
                    return 590 // forfait
                return 590 + (surface - 100) * 3
            case DeliveryType.APARTMENT_INVENTORY_FURNISHED:
                if (surface === 1 || surface === 2)
                    return 109
                else if (surface === 3 || surface === 4)
                    return 139
                return 199
            case DeliveryType.APARTMENT_INVENTORY_NOT_FURNISHED:
                if (surface === 1 || surface === 2)
                    return 89
                else if (surface === 3 || surface === 4)
                    return 109
                return 149
            case DeliveryType.HOME_INVENTORY_FURNISHED:
                if (surface === 1 || surface === 2)
                    return 169
                else if (surface === 3 || surface === 4)
                    return 179
                return 209
            case DeliveryType.HOME_INVENTORY_NOT_FURNISHED:
                if (surface === 1 || surface === 2)
                    return 129
                else if (surface === 3 || surface === 4)
                    return 149
                return 169
            case DeliveryType.GO_NO_GO_HOME:
                if (surface <= 120)
                    return 450 // forfait
                return 450 + (surface - 120) * 3.75
            case DeliveryType.GO_NO_GO_APARTMENT:
                if (surface <= 120)
                    return 380 // forfait
                return 380 + (surface - 120) * 3.17
            default:
                console.log('Sorry, we are out of ' + deliveryType + '.');
                return 'Erreur'
        }
    }

    getTransportQuantity(deliveryType) {
        switch (deliveryType) {
            case DeliveryType.CUSTOM:
                return 1
            case DeliveryType.VEFA_LIFTING_RESERVATION:
                return 1
            case DeliveryType.VEFA_HOME_BULKHEAD:
                return 1
            case DeliveryType.VEFA_HOME_PRE_DELIVERY:
                return 1
            case DeliveryType.VEFA_HOME_RECEPTION_DELIVERY:
                return 1
            case DeliveryType.VEFA_APARTMENT_BULKHEAD:
                return 1
            case DeliveryType.VEFA_APARTMENT_PRE_DELIVERY:
                return 1
            case DeliveryType.VEFA_APARTMENT_RECEPTION_DELIVERY:
                return 1
            case DeliveryType.APARTMENT:
                return 1
            case DeliveryType.HOME:
                return 1
            case DeliveryType.HOME_WITH_ROOFTOP:
                return 1
            case DeliveryType.COUNTERVISIT:
                return 1
            case DeliveryType.SWIMMING_POOL:
                return 1
            case DeliveryType.ROOFING:
                return 1
            case DeliveryType.GARDEN:
                return 1
            case DeliveryType.WATERING:
                return 1
            case DeliveryType.GARDEN_WATERING:
                return 1
            case DeliveryType.CRAWLSPACE:
                return 1
            case DeliveryType.MOISTURE_CHECK:
                return 1
            case DeliveryType.DELIVERY_ASSISTANCE_COMMON_PART:
                return 1
            case DeliveryType.CCMI_FOUNDATION:
                return 1
            case DeliveryType.CCMI_BIG_WORK:
                return 1
            case DeliveryType.CCMI_BULKHEAD:
                return 1
            case DeliveryType.CCMI_COPE:
                return 1
            case DeliveryType.CCMI_RECEPTION_DELIVERY:
                return 1
            case DeliveryType.CCMI_SERENITY_PACK:
                return 5
            case DeliveryType.CRACKS_CHECK:
                return 1
            case DeliveryType.FOLLOW_UP_CONSTRUCTION:
                return 1
            case DeliveryType.RECEPTION_CONSTRUCTION_SITE:
                return 0
            case DeliveryType.APARTMENT_INVENTORY_FURNISHED:
                return 0
            case DeliveryType.APARTMENT_INVENTORY_NOT_FURNISHED:
                return 0
            case DeliveryType.HOME_INVENTORY_FURNISHED:
                return 0
            case DeliveryType.HOME_INVENTORY_NOT_FURNISHED:
                return 0
            case DeliveryType.GO_NO_GO_APARTMENT:
                return 0
            case DeliveryType.GO_NO_GO_HOME:
                return 0
            default:
                console.log('Sorry, we are out of ' + deliveryType + '.');
                return 'Erreur'
        }
    }

    getTotalPricing(delivery) {
        const deliveryType = delivery.type
        const surface = delivery.surface
        const discount = delivery.discount ? delivery.discount : 0

        switch (deliveryType) {
            case DeliveryType.CUSTOM:
                return this.getUnitPricing(deliveryType, surface) - (this.getUnitPricing(deliveryType, surface) * discount / 100)
            case DeliveryType.COUNTERVISIT:
                return this.getUnitPricing(deliveryType, surface) - (this.getUnitPricing(deliveryType, surface) * discount / 100)
            case DeliveryType.APARTMENT_INVENTORY_FURNISHED:
                return this.getUnitPricing(deliveryType, surface) - (this.getUnitPricing(deliveryType, surface) * discount / 100)
            case DeliveryType.APARTMENT_INVENTORY_NOT_FURNISHED:
                return this.getUnitPricing(deliveryType, surface) - (this.getUnitPricing(deliveryType, surface) * discount / 100)
            case DeliveryType.HOME_INVENTORY_FURNISHED:
                return this.getUnitPricing(deliveryType, surface) - (this.getUnitPricing(deliveryType, surface) * discount / 100)
            case DeliveryType.HOME_INVENTORY_NOT_FURNISHED:
                return this.getUnitPricing(deliveryType, surface) - (this.getUnitPricing(deliveryType, surface) * discount / 100)
            default:
                return (this.getUnitPricing(deliveryType, surface) * this.getQuantity(deliveryType, surface)) - ((this.getUnitPricing(deliveryType, surface) * this.getQuantity(deliveryType, surface)) * discount / 100)
        }
    }

    getTotalPricingForAllDeliveries(deliveries, freeTransport) {
        var price = 0
        deliveries.forEach(delivery => {
            price += this.getTotalPricing(delivery)
            if (!freeTransport) {
                price += this.getTransportQuantity(delivery.type) * 60
            }
        });
        return price
    }
}

export default DeliveryManager;
